import { useContext } from 'react';

import { MarketDesignContext } from 'src/pages/MarketDesignMobile';

const useMarketDesignContext = () => useContext(MarketDesignContext);

export default useMarketDesignContext;
